import logo from '../../assets/logo.png';

import { Container, Topbar, Logo } from './styles';

export function Header() {
    return (
        <Container>
            <Topbar>
                11 4689 8686&nbsp;&nbsp;&nbsp;&nbsp;atendimento@epharma.com.br
            </Topbar>
            <Logo>
                <div className='logo'> 
                    <img src={logo} alt="ePharma Inovação, integração e cuidado em saúde" />
                </div>
                <div className='title'>
                    <p>Cadastro no Balcão</p>
                </div>
            </Logo>
        </Container>
    );
}